// Imports MUI Components
import { Stack,} from "@mui/material"

// Import Atoms
import ButtonComp from "../../atoms/button/Button"

const HeaderButtonGroup = ({ }) => {
  return (
    <>
      <Stack 
        direction="row" 
        spacing={4}
        sx={{
          display: {
            xs: "none",
            sm: "none",
            md: "none",
            lg: "flex",
            xl: "flex",
          },
          alignItems: "center"
        }}
      >

        <ButtonComp
          variant="text"
          noElevate={true}
          noRipple={true}
          label="Home"
          color="default"
          paddings="small"
          background="none"
          font="default"
          weight="default"
          transform="default"
          selected={true}
          keys={false}
          hoverTextColor="special"
          hoverBackground="none"
          hoverBorder="none"
          noRead={false}
          type="default"
          justify="default"
          destination="/"
          open={true}/>

        <ButtonComp
          variant="text"
          noElevate={true}
          noRipple={true}
          label="Services"
          color="default"
          paddings="small"
          background="none"
          font="default"
          weight="default"
          transform="default"
          selected={true}
          keys={false}
          hoverTextColor="special"
          hoverBackground="none"
          hoverBorder="none"
          noRead={false}
          type="default"
          justify="default"
          destination="/services"
          open={true}/>

        <ButtonComp
          variant="text"
          noElevate={true}
          noRipple={true}
          label="About"
          color="default"
          paddings="small"
          background="none"
          font="default"
          weight="default"
          transform="default"
          selected={true}
          keys={false}
          hoverTextColor="special"
          hoverBackground="none"
          hoverBorder="none"
          noRead={false}
          type="default"
          justify="default"
          destination="/about"
          open={true}/>

        <ButtonComp
          variant="text"
          noElevate={true}
          noRipple={true}
          label="Contact"
          color="default"
          paddings="small"
          background="none"
          font="default"
          weight="default"
          transform="default"
          selected={true}
          keys={false}
          hoverTextColor="special"
          hoverBackground="none"
          hoverBorder="none"
          noRead={false}
          type="default"
          justify="default"
          destination="/contact"
          open={true}/>

      </Stack>

    </>
  );
};

export default HeaderButtonGroup;